const STORAGE_KEY = 'product_updates_last_seen_release_id'

export function getLastSeenReleaseId(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

export function setLastSeenReleaseId(id: string | null): void {
  try {
    if (id == null || id === '') localStorage.removeItem(STORAGE_KEY)
    else localStorage.setItem(STORAGE_KEY, id)
  } catch {
    /* ignore quota / private mode */
  }
}

/** Latest release id when sorted by date descending (ISO strings sort lexicographically). */
export function getLatestReleaseIdSorted(releases: { id: string; date: string }[]): string | null {
  if (!releases.length) return null
  const sorted = [...releases].sort((a, b) => b.date.localeCompare(a.date))
  return sorted[0].id
}

/** @deprecated Prefer getLatestReleaseIdSorted unless releases are already newest-first */
export function getLatestReleaseIdFromPayload(releases: { id: string }[]): string | null {
  if (!releases.length) return null
  return releases[0].id
}

export function hasUnreadProductUpdates(releases: { id: string; date: string }[]): boolean {
  const latest = getLatestReleaseIdSorted(releases)
  if (!latest) return false
  const seen = getLastSeenReleaseId()
  if (!seen) return true
  return seen !== latest
}
